import useFetch from '@/composables/useFetch';
import { PaginationResponse } from '@/model/api';
import { Config, ConfigPaginationRequest } from '@/model/config';

export async function getConfig(name: string) {
	const res = await useFetch<Config>({
		method: 'GET',
		url: `/config/${name}`
	});
	return res.data;
}

export async function getConfigs(filter: ConfigPaginationRequest) {
	const res = await useFetch<PaginationResponse<Config>>({
		method: 'GET',
		url: `/config`,
		params: filter,
		signalUUID: `GET_CONFIG_PAGINATION`
	});
	return res.data;
}

export async function createConfig(data: Config) {
	return await useFetch({
		method: 'POST',
		url: `/config`,
		data
	});
}

export async function updateConfig(config: Config) {
	return await useFetch({
		method: 'PATCH',
		url: `/config/${config.name}`,
		data: { value: config.value }
	});
}

export async function deleteConfig(name: string) {
	return await useFetch({
		method: 'DELETE',
		url: `/config/${name}`
	});
}

export async function reloadConfig() {
	return await useFetch({
		method: 'POST',
		url: `/config/reload`
	});
}
